export enum EcPrintLocationParamValues {
  POS = '0',
  TERMINAL = '1'
}
